import { useLoanOfferFormContext } from '@sec-loans-ui/loan-offer/steps/formContext'
import { FormStep } from '@sec-loans-ui/loan-offer/steps/FormStep'
import { useWizardForm } from '@ui-common/hooks'
import { useIntl } from 'react-intl'

export const InstallmentStep = () => {
  const { formatMessage } = useIntl()
  const { proceed, loanOffer } = useLoanOfferFormContext()

  const methods = useWizardForm({
    defaultValues: loanOffer,
  })

  return (
    <FormStep
      allowBack={true}
      subHeader={formatMessage({ id: 'loan-offer-installment-step-heading' })}
      formMethods={methods}
      onSubmit={proceed}
    />
  )
}
